import { render, staticRenderFns } from "./space-template.vue?vue&type=template&id=2cc9ec27&scoped=true&"
import script from "./space-template.vue?vue&type=script&lang=ts&"
export * from "./space-template.vue?vue&type=script&lang=ts&"
import style0 from "./space-template.vue?vue&type=style&index=0&id=2cc9ec27&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9ec27",
  null
  
)

export default component.exports